'use client'

import Pusher from 'pusher-js'
import { createContext, PropsWithChildren, useContext, useEffect } from 'react'
import { z } from 'zod'

import { useSession } from '../index.ts'
import { usePusher } from './pusher.tsx'

interface SubscribeNotificationContext {}

const SubscribeNotificationContext = createContext<SubscribeNotificationContext>(
  {} as SubscribeNotificationContext,
)

export const SubscribeNotificationProvider = ({
  children,
  subscribeFn,
}: PropsWithChildren<{
  subscribeFn: (props: { pusher: Pusher; userId: number }) => void
}>) => {
  const { pusher } = usePusher()
  const session = useSession()
  const userId = z.coerce.number().optional().parse(session.data?.user?.id)

  useEffect(() => {
    if (userId) subscribeFn({ pusher, userId })
  }, [pusher, userId])

  return (
    <SubscribeNotificationContext.Provider value={{}}>
      {children}
    </SubscribeNotificationContext.Provider>
  )
}

export const useSubscribeNotification = () => {
  const context = useContext(SubscribeNotificationContext)

  if (!context) {
    throw new Error(
      'useSubscribeNotification must be used within a SubscribeNotificationContextProvider',
    )
  }

  return context
}
